import { Component, OnInit } from '@angular/core';
import {Observable} from 'rxjs';
import {Store} from '@ngrx/store';
import {AppState, selectAuthState} from '../../../../store/app.states';
import {MatDialog} from '@angular/material/dialog';
import {Router} from '@angular/router';
import {AuthService} from '../../../../services/auth.service';
import {PatientService} from '../../../../services/patient.service';
import {ErrorDialogComponent} from '../../../user-actions/error-dialog/error-dialog.component';

@Component({
  selector: 'app-choose-questionnaire',
  templateUrl: './choose-questionnaire.component.html',
  styleUrls: ['./choose-questionnaire.component.css']
})
// In questo componente vengono elencati i questionari compilabili dal paziente in modo autonomo rispetto
// a quelli che vengono mandati periodicamente dal sistema o quelli mandati dal medico.
export class ChooseQuestionnaireComponent implements OnInit {
  getAuthState: Observable<any>;
  customState: Observable<any>;
  isAuthenticated: boolean;
  user = null;
  errorMessage = null;
  message;
  title = 'Benvenuto';
  back = true;
  destination = '/contact-center';
  questionnaireTypeList: string[];
  descriptionQuestionnaireMap;
  mapReady = false;
  // questionnaires1 sono i questionari che misurano l'attività di malattia
  questionnaires1: string[];
  // questionnaires2 sono i questionari che misurano l'impatto della malattia sulla vita
  questionnaires2: string[];
  // questionnaires3 sono i questionari che misurano la compatibilità con la terapia.
  questionnaires3: string[];

  constructor(private store: Store<AppState>,
              private dialog: MatDialog,
              private router: Router,
              private patientService: PatientService) {
    this.getAuthState = this.store.select(selectAuthState);
  }

  ngOnInit(): void {
    this.getAuthState.subscribe((state) => {
      this.isAuthenticated = state.isAuthenticated;
      this.user = JSON.parse(localStorage.getItem('user'));
      this.errorMessage = state.errorMessage;
      // Chiedo al server l'elenco dei questionari che può compilare questo paziente.
      this.patientService.getQuestionnairesTypeList(this.user.email).subscribe(questionnairesType => {
            // this.questionnaireTypeList = questionnairesType.filter(q => !q.startsWith('CLINICAL'));
            // this.compileMap(this.questionnaireTypeList);
            this.setInMapAndLists(questionnairesType);
            this.mapReady = true;
        }
      );
    });
  }

  // Funzione che nel caso oggi non abbia già compilato un questionario di questo tipo, ti permette di
  // andare alla pagina dove è presente il questionario.
  goTo(type: string) {
    this.patientService.hasQuestionnaireAlreadyCompletedToday(this.user.ssn, type).subscribe(
      hasCompleted => {
        if (hasCompleted === false) {
          this.router.navigateByUrl('/questionnaire-compile/' + type.toLowerCase() + '/' + 0 + '/' + 0 + '/' + this.user.ssn + '/choose-questionnaire');
        }
        if (hasCompleted === true) {
          this.openErrorDialog('Hai già inviato un questionario di questo tipo oggi. ' +
            'Scegline un altro oppure attendi fino a domani per potere mandare ancora un: ' + type);
        }
      }
    );
  }

  openErrorDialog(message: string): void {
    this.dialog.open(ErrorDialogComponent, {
      width: '500px',
      height: '350px',
      data: message
    });
  }

  // Costruiamo una mappa per abbinare ad ogni questionario una descrizione.
  setInMapAndLists(questionnaires: string[]) {
    this.questionnaires1 = [];
    this.questionnaires2 = [];
    this.questionnaires3 = [];
    this.descriptionQuestionnaireMap = new Map();
    questionnaires.forEach(type => {
      const q = type.toLowerCase();
      switch (q) {
        /*case 'clinical-sccai':
          this.descriptionQuestionnaireMap[type] = '';
          break;
        case 'clinical-hbi':
          this.descriptionQuestionnaireMap[type] = '';
          break;
        case 'clinical-prism':
          this.descriptionQuestionnaireMap[type] = '';
          break;*/
        case 'eortc-qlq':
          this.descriptionQuestionnaireMap[type] = ''; // Questionario inutilizzato
          break;
        case 'eq5d5l':
          this.questionnaires2.push(type);
          this.descriptionQuestionnaireMap[type] = ': Questionario per il monitoraggio delle attività abituali del paziente quali: lavoro e cura della persona ma anche riguardante la salute fisica e psicologica.';
          break;
        case 'hads':
          this.descriptionQuestionnaireMap[type] = ''; // Questionario inutilizzato
          break;
        case 'hbi':
          this.questionnaires1.push(type);
          this.descriptionQuestionnaireMap[type] = ': Questionario utilizzato per monitorare la salute del paziente con malattia di Crohn considerando parametri clinici con focus sull’attività e dolore addominale.';
          break;
        case 'ibd-disk':
          this.questionnaires2.push(type);
          this.descriptionQuestionnaireMap[type] = ': Questionario per valutare l’impatto della malattia sulla vita del paziente, il questionario parte dalle interazioni interpersonali, educazione e lavoro fino allo stato di salute in generale.';
          break;
        case 'ipaq-sf':
          this.questionnaires2.push(type);
          this.descriptionQuestionnaireMap[type] = ': Questionario sull’attività fisica quotidiana svolta negli ultimi 7 giorni.';
          break;
        case 'miah-cd': // tolto da richiesta del dottore
//          this.questionnaires1.push(type);
// tslint:disable-next-line:max-line-length
//           this.descriptionQuestionnaireMap[type] = ': Questionario per il monitoraggio della salute del paziente con malattia di Crohn che tiene conto del numero ed urgenza delle evacuazioni.';
          break;
        case 'miah-uc': // tolto da richiesta del dottore
//          this.questionnaires1.push(type);
// tslint:disable-next-line:max-line-length
//          this.descriptionQuestionnaireMap[type] = ': Questionario per il monitoraggio della salute del paziente con colite ulcerosa che tiene conto del dolore addominale e urgenza evacuativa.';
          break;
        case 'mmas8':
          this.questionnaires3.push(type);
          this.descriptionQuestionnaireMap[type] = ': Questionario sulla costanza nell’assunzione dei farmaci. ';
          break;
        case 'patient-sccai':
          this.questionnaires1.push(type);
          this.descriptionQuestionnaireMap[type] = ': Questionario per il monitoraggio della salute del paziente che tiene conto del numero ed urgenza delle evacuazioni.';
          break;
        case 'phq9':
          this.questionnaires2.push(type);
          this.descriptionQuestionnaireMap[type] = ': Questionario utilizzato per la diagnosi, il monitoraggio e la determinazione della gravità della depressione.';
          break;
        case 'prism':
          this.questionnaires2.push(type);
          this.descriptionQuestionnaireMap[type] = ': Valutazione grafica dell’impatto della malattia sulla vita del paziente.';
          break;
        case 'psqi':
          this.questionnaires2.push(type);
          this.descriptionQuestionnaireMap[type] = ': Questionario per la valutazione del sonno nell’ultimo mese.';
          break;
        /*case 'sibdq':
          this.questionnaires2.push(type);
          this.descriptionQuestionnaireMap[type] = ': Questionario con lo scopo di valutare gli effetti che le malattie infiammatorie croniche dell\'intestino hanno sulle attività quotidiane e sulla qualità della vita.';
          break;*/
        case 'tsqm':
          this.questionnaires3.push(type);
          this.descriptionQuestionnaireMap[type] = ': Questionario che valuta il livello di soddisfazione del paziente riguardo alla terapia farmacologica in uso.';
          break;
        case 'wpai':
          this.questionnaires2.push(type);
          this.descriptionQuestionnaireMap[type] = ': Questionario utilizzato per il monitoraggio dell’influenza della malattia sull’attività lavorativa del paziente.';
          break;
        case 'ibdq':
          this.questionnaires2.push(type);
          this.descriptionQuestionnaireMap[type] = ': Questionario disegnato per capire come si è sentito nelle ultime due settimane, con un riguardo particolare verso i sintomi della malattia intestinale, sul suo stato e sull’umore.';
          break;
          case 'lars':
            this.questionnaires2.push(type);
            this.descriptionQuestionnaireMap[type] = ': Questionario LARS';
            break;
      }
    });
    console.log(this.questionnaires1);
  }
}
